import { render, staticRenderFns } from "./projectPublicity.vue?vue&type=template&id=4e318a48"
import script from "./projectPublicity.vue?vue&type=script&lang=js"
export * from "./projectPublicity.vue?vue&type=script&lang=js"
import style0 from "./projectPublicity.vue?vue&type=style&index=0&id=4e318a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports